"use client";

/**
 * Presenter-chrome subcomponent: time-warp slider + apply button.
 * Range 1–50×. The label differs between manual mode (within-screen
 * pacing) and auto mode (whole-scenario pacing).
 */
export function WarpControls({
  warp,
  onWarpChange,
  onApply,
  manualMode,
}: {
  warp: number;
  onWarpChange: (warp: number) => void;
  onApply: (warp: number) => void;
  manualMode: boolean;
}) {
  return (
    <>
      <p className="mt-3 text-orbitra-teal-soft uppercase tracking-[0.18em]">
        {manualMode ? `Within-screen pacing · ${warp}×` : `Time-warp · ${warp}×`}
      </p>
      <div className="mt-1 flex items-center gap-2">
        <input
          type="range"
          min={1}
          max={50}
          step={1}
          value={warp}
          onChange={(e) => onWarpChange(Number(e.target.value))}
          className="flex-1 accent-[var(--state-verified)]"
        />
        <button
          onClick={() => onApply(warp)}
          className="rounded border border-state-verified/30 px-2 py-0.5 text-state-verified hover:bg-state-verified/15"
        >
          apply
        </button>
      </div>
    </>
  );
}
